cb.define([], function () {
  var AA_pc_addressarchives_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      let mode = viewmodel.getParams().mode;
      let sourcetype = viewmodel.get('sourcetype');
      const diffSourcetype = (viewmodel) => {
        viewmodel.get('parent_name').setDisabled(true);
        if (sourcetype && "edit".equalsIgnoreCase(mode)) {
          let _arr = ['name', 'showName', 'code', 'zipCode', 'order'];
          _arr.forEach(v => {
            viewmodel.get(v).setDisabled(true)
          })
        }
      };
      viewmodel.on('afterLoadData', function () {
        diffSourcetype(viewmodel);
      })
    },
  };
  try {
    module.exports = AA_pc_addressarchives_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return AA_pc_addressarchives_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_pc_addressarchives_VM.Extend.js